"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importDefault(require("react"));
const react_redux_1 = require("react-redux");
const redux_1 = require("redux");
const UI_1 = require("~/components/UI");
const actions_1 = require("~/store/actions");
const selectors_1 = require("~/store/selectors");
function CatalogTabs() {
    const { data } = (0, react_redux_1.useSelector)(selectors_1.selectCatalogMeta);
    const selectedSeriesType = (0, react_redux_1.useSelector)(selectors_1.selectCatalogSeriesType);
    const { dispatchSetCatalogSeriesType } = (0, redux_1.bindActionCreators)({
        dispatchSetCatalogSeriesType: actions_1.setCatalogSeriesType,
    }, (0, react_redux_1.useDispatch)());
    if (!data) {
        return null;
    }
    return (react_1.default.createElement(UI_1.Tabs, { tabs: data.seriesTypes.map((seriesType) => ({
            label: seriesType.name,
            id: seriesType.id,
            value: seriesType,
        })), selected: selectedSeriesType, onChange: dispatchSetCatalogSeriesType }));
}
exports.default = CatalogTabs;
